export default "__VITE_ASSET__CNNCojz4__"